<script setup>
import { useCurrency } from '@/composables/useCurrency'
import { useI18n } from 'vue-i18n'

defineProps({ user: { type: Object, required: true } })

const { t } = useI18n()
const { formatDate } = useCurrency()

const initials = (name) => (name || '?').split(' ').map(s => s[0]).filter(Boolean).slice(0, 2).join('').toUpperCase()
</script>

<template>
  <div class="flex items-start gap-3">
    <div class="shrink-0 inline-flex items-center justify-center h-10 w-10 rounded-full bg-[color:var(--accentSoft)] text-[color:var(--accent)] text-sm font-medium">
      {{ initials(user.full_name) }}
    </div>
    <div class="min-w-0 flex-1">
      <div class="truncate text-[color:var(--ink)] font-medium">
        {{ user.full_name }}
      </div>
      <div class="text-xs text-[color:var(--muted)] truncate">
        {{ user.email }}
      </div>
      <div class="text-[10px] mt-1 mono uppercase tracking-wide text-[color:var(--muted)]">
        {{ t(`users.roles.${user.role}`) }}
      </div>
    </div>
    <div
      v-if="user.created_at"
      class="shrink-0 text-xs text-[color:var(--muted)] tabular-nums"
    >
      {{ formatDate(user.created_at) }}
    </div>
  </div>
</template>
